// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const carnivine: PokeData = {
  "id": 455,
  "name": "carnivine",
  "height": 14,
  "weight": 270,
  "base_experience": 159,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "bind",
    "vine-whip",
    "bite",
    "absorb",
    "growth",
    "stun-spore",
    "sleep-powder",
    "feint-attack",
    "sweet-scent",
    "crunch",
    "stockpile",
    "spit-up",
    "swallow",
    "ingrain",
    "wring-out",
    "seed-bomb",
    "energy-ball",
    "power-whip",
    "grass-knot",
    "acid-spray",
    "leaf-tornado"
  ],
  "moves": [
    "vine-whip",
    "bite",
    "stun-spore",
    "crunch",
    "energy-ball",
    "power-whip",
    "leaf-tornado",
    "branch-poke",
    "frenzy-plant",
    "synthesis",
    "solar-beam",
    "grassy-terrain",
    "razor-leaf"
  ],
  "evolution_chain": {
    "id": 236,
    "item": null,
    "species": [
      {
        "name": "carnivine",
        "order": 475,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 84,
    "ability_power": 183
  },
  "stat_changes": [],
  "catch_rate": 200,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
